import { ComponentNameEnum } from '@/types';

const getGameTestButtonFieldConfig = (gameType: 'wheel' | 'slotMachine' | 'scratchCard') => ({
  componentName: ComponentNameEnum.GAME_TEST_BUTTON,
  options: {
    gameType,
  },
});

export default getGameTestButtonFieldConfig;
